export async function cleanLocalStorageCache() {
    const keysToClean = Object.keys(localStorage).filter(key => key.includes("mais_vendas_cache_"))

    if(!keysToClean) {
        return;
    }

    for (const key of keysToClean) {
        await localStorage.removeItem(key);
    }
}